export const formatDirectWorkforceDisplay = (
  value: boolean | null | undefined
): string | null => {
  if (value == null) {
    return null;
  }
  return value ? "Direct" : "Contractor";
};
